// AUTO-GENERATED — do not edit.
//
// Source:    packages/core/src/portal/pageCatalogue.js
// Regenerate: node tools/gen-client-catalogue.js
//
// The web client cannot import @ameca/core (packages/core is not a workspace),
// so the catalogue is copied here. Both the Role Permissions dialog and the
// Add User form read it, which is what keeps them describing a role the same
// way.

export const PAGE_CATALOGUE = [
  {
    "module": "Dashboard & Overview",
    "pages": [
      {
        "name": "School Overview",
        "path": "/school-overview"
      }
    ]
  },
  {
    "module": "Class Management",
    "pages": [
      {
        "name": "Class Overview",
        "path": "/class-management"
      },
      {
        "name": "Add New Class",
        "path": "/class-management/add-class"
      },
      {
        "name": "Manage Classes",
        "path": "/class-management/manage-classes"
      },
      {
        "name": "Class Assignments",
        "path": "/class-management/class-assignments"
      },
      {
        "name": "Class Reports",
        "path": "/class-management/class-reports"
      }
    ]
  },
  {
    "module": "Subject Management",
    "pages": [
      {
        "name": "Subject Overview",
        "path": "/subject-management"
      },
      {
        "name": "Add New Subject",
        "path": "/subject-management/add-subject"
      },
      {
        "name": "Manage Subjects",
        "path": "/subject-management/manage-subjects"
      },
      {
        "name": "Subject Assignments",
        "path": "/subject-management/subject-assignments"
      },
      {
        "name": "Subject Reports",
        "path": "/subject-management/subject-reports"
      }
    ]
  },
  {
    "module": "Staff Management",
    "pages": [
      {
        "name": "Role Permissions",
        "path": "/role-permissions"
      },
      {
        "name": "User Management",
        "path": "/user-list"
      },
      {
        "name": "User Form",
        "path": "/user-form"
      },
      {
        "name": "Staff Evaluation",
        "path": "/staff-evaluation"
      }
    ]
  },
  {
    "module": "Student Management",
    "pages": [
      {
        "name": "Admissions",
        "path": "/student-admissions"
      },
      {
        "name": "Student Directory",
        "path": "/student-directory"
      },
      {
        "name": "Attendance Summary",
        "path": "/attendance-summary"
      },
      {
        "name": "Students Discipline",
        "path": "/students-discipline"
      },
      {
        "name": "Class Promotion Summary",
        "path": "/class-promotion-summary"
      },
      {
        "name": "ID Card Workshop",
        "path": "/id-card-workshop"
      }
    ]
  },
  {
    "module": "Academics",
    "pages": [
      {
        "name": "Evaluation Control Center",
        "path": "/evaluation-control-center"
      },
      {
        "name": "Academic Calendar",
        "path": "/calendar"
      },
      {
        "name": "Timetable",
        "path": "/timetable"
      },
      {
        "name": "Grading Scales",
        "path": "/grading-scales"
      },
      {
        "name": "Report Card Studio",
        "path": "/academics/report-card-studio"
      },
      {
        "name": "Academic Transcripts",
        "path": "/student-transcripts",
        "secondaryOnly": true
      }
    ]
  },
  {
    "module": "Teaching & Learning",
    "pages": [
      {
        "name": "Take attendance",
        "path": "/teacher/attendance-recording"
      },
      {
        "name": "Enter marks",
        "path": "/teacher/student-grading"
      },
      {
        "name": "Class results",
        "path": "/classmaster/class-academic-performance"
      },
      {
        "name": "Class discipline",
        "path": "/classmaster/class-discipline"
      },
      {
        "name": "Subject performance",
        "path": "/subjecthead/subject-performance-matrix",
        "secondaryOnly": true
      },
      {
        "name": "Departmental report",
        "path": "/subjecthead/subject-report",
        "secondaryOnly": true
      }
    ]
  },
  {
    "module": "Finance",
    "pages": [
      {
        "name": "Fee Types",
        "path": "/fee-types"
      },
      {
        "name": "Fees",
        "path": "/finance/fee-structures"
      },
      {
        "name": "Payment Processing",
        "path": "/finance/payments"
      },
      {
        "name": "Manage Fee Payments",
        "path": "/finance/manage-fee-payments"
      },
      {
        "name": "Expenses",
        "path": "/expenses"
      },
      {
        "name": "Budgets",
        "path": "/budgets"
      },
      {
        "name": "Financial Reports",
        "path": "/financial-reports"
      },
      {
        "name": "Salary Management",
        "path": "/salary-management"
      },
      {
        "name": "Subscription Renewal",
        "path": "/finance/subscription-renewal"
      }
    ]
  },
  {
    "module": "Facilities",
    "pages": [
      {
        "name": "Library Dashboard",
        "path": "/facilities/library-dashboard"
      },
      {
        "name": "Transport Routes",
        "path": "/facilities/transport-routes"
      },
      {
        "name": "Inventory Control",
        "path": "/facilities/inventory-control"
      }
    ]
  },
  {
    "module": "Communication",
    "pages": [
      {
        "name": "Announcements",
        "path": "/communication/announcements"
      }
    ]
  },
  {
    "module": "Support & Maintenance",
    "pages": [
      {
        "name": "Submit Ticket",
        "path": "/support/submit-ticket"
      },
      {
        "name": "Help Center",
        "path": "/support/help-center"
      }
    ]
  },
  {
    "module": "School Setup & Configuration",
    "pages": [
      {
        "name": "School Settings",
        "path": "/school-setup-and-configuration/school-settings"
      },
      {
        "name": "Communication Settings",
        "path": "/school-setup-and-configuration/communication-settings"
      },
      {
        "name": "Backup & Security",
        "path": "/school-setup-and-configuration/backup-security"
      }
    ]
  },
  {
    "module": "Parent Portal",
    "pages": [
      {
        "name": "Dashboard",
        "path": "/parent/dashboard"
      },
      {
        "name": "Children & Academics",
        "path": "/parent/children-academics"
      },
      {
        "name": "Attendance Records",
        "path": "/parent/attendance"
      },
      {
        "name": "Fees & Payments",
        "path": "/parent/fees-payments"
      }
    ]
  }
];

export const ALWAYS_AVAILABLE_PAGES = [
  "/communication/messages",
  "/my-profile"
];

export const PATH_ALIASES = {
  "/fee-structure-manager": "/finance/fee-structures",
  "/payment-processing": "/finance/payments",
  "/report-card-studio": "/academics/report-card-studio",
  "/student/messages": "/communication/messages",
  "/teacher/class-discipline": "/classmaster/class-discipline",
  "/teacher/class-academic-performance": "/classmaster/class-academic-performance",
  "/teacher/attendance": "/teacher/attendance-recording",
  "/teacher/marks": "/teacher/student-grading",
  "/parent/messages": "/communication/messages"
};

export const CATALOGUE_PATHS = PAGE_CATALOGUE.flatMap((m) => m.pages.map((p) => p.path));

// Emitted from the real function rather than retyped, so it cannot drift.
export const levelLabel = function levelLabel(level) {
  const key = String(level || '').trim().toLowerCase();
  if (!key) return '';
  const known = {
    nursery: 'Nursery',
    primary: 'Primary',
    first_cycle: 'First Cycle',
    second_cycle: 'Second Cycle',
  };
  return known[key] || key.replace(/[-_]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

export function canonicalPath(p) {
  return PATH_ALIASES[p] || p;
}

export function describeCataloguePath(pathname) {
  for (const m of PAGE_CATALOGUE) {
    for (const p of m.pages) if (p.path === pathname) return p.name;
  }
  const named = {
    '/communication/messages': 'Messages',
    '/my-profile': 'My Profile',
  };
  if (named[pathname]) return named[pathname];
  const seg = String(pathname || '').split('/').filter(Boolean).pop() || String(pathname || '');
  return seg.replace(/[-_]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function roleGrantSummary(permissions, { phaseCode } = {}) {
  const held = new Set(
    (permissions || [])
      .map((p) => (typeof p === 'string' ? p : p && p.name))
      .filter((p) => typeof p === 'string' && p.startsWith('/'))
      .map(canonicalPath)
  );

  // A secondary-only page is not listed in a nursery/primary session — naming a
  // page the phase refuses would be a promise the role cannot keep.
  const nurPri = String(phaseCode || '').trim().toLowerCase() === 'nur_pri';

  const modules = PAGE_CATALOGUE
    .map((m) => ({
      module: m.module,
      pages: m.pages.filter((p) => held.has(p.path) && !(nurPri && p.secondaryOnly)),
    }))
    .filter((m) => m.pages.length > 0);

  const granted = modules.flatMap((m) => m.pages.map((p) => p.path));
  const listed = new Set([...CATALOGUE_PATHS, ...ALWAYS_AVAILABLE_PAGES]);

  return {
    modules,
    granted,
    defaults: ALWAYS_AVAILABLE_PAGES.map((p) => ({ path: p, name: describeCataloguePath(p) })),
    extra: [...held].filter((p) => !listed.has(p)),
  };
}
